import { useEffect } from 'react';
import { usePageTitle, setDocumentTitle } from '../utils/translation';

interface PageTitleProps {
  titleKey: string;
  defaultTitle?: string;
}

/**
 * Component for managing page titles
 * Automatically sets document.title when mounted
 * 
 * @param titleKey - Translation key for the page title
 * @param defaultTitle - Default title to use if translation is not found
 */
export default function PageTitle({ titleKey, defaultTitle = 'Piika' }: PageTitleProps) {
  const pageTitle = usePageTitle(titleKey, defaultTitle);
  
  useEffect(() => {
    setDocumentTitle(pageTitle);
  }, [pageTitle]);
  
  // This component doesn't render anything visible
  return null;
} 